<div class="custom-spreadsheet-wrapper">
  <!-- Barra de ferramentas customizada -->
  <div class="spreadsheet-toolbar" *ngIf="props.showToolbar">
    <nz-space nzSize="small">
      <button *nzSpaceItem nz-button nzSize="small" (click)="addSheet()" [nzTitle]="'spreadsheet.addSheet' |translateTA" nz-tooltip>
        <i nz-icon nzType="plus"></i>
        {{ 'spreadsheet.addSheet' |translateTA }}
      </button>

      <button *nzSpaceItem nz-button nzSize="small" (click)="exportExcel()" [nzTitle]="'spreadsheet.export' |translateTA" nz-tooltip>
        <i nz-icon nzType="download"></i>
        {{ 'spreadsheet.export' |translateTA }}
      </button>

      <nz-upload *nzSpaceItem nzAccept=".xlsx,.xls" [nzBeforeUpload]="importExcel" [nzShowUploadList]="false">
        <button nz-button nzSize="small" [nzTitle]="'spreadsheet.import' |translateTA" nz-tooltip>
          <i nz-icon nzType="upload"></i>
          {{ 'spreadsheet.import' |translateTA }}
        </button>
      </nz-upload>
    </nz-space>
  </div>

  <!-- Barra de fórmulas -->
  <div class="spreadsheet-formula-bar" *ngIf="props.showFormulaBar">
    <nz-input-group nzCompact>
      <nz-select nzStyle="width: 80px" [nzValue]="selectedCell.row >= 0 ? columnHeaders[selectedCell.col] + (selectedCell.row + 1) : 'A1'">
        <nz-option [nzLabel]="selectedCell.row >= 0 ? columnHeaders[selectedCell.col] + (selectedCell.row + 1) : 'A1'" [nzValue]="selectedCell.row >= 0 ? columnHeaders[selectedCell.col] + (selectedCell.row + 1) : 'A1'"></nz-option>
      </nz-select>
      <input nz-input nzStyle="width: calc(100% - 80px)" placeholder="{{ 'spreadsheet.formulaPlaceholder' |translateTA }}" [(ngModel)]="currentFormula" />
    </nz-input-group>
  </div>

  <!-- Planilha customizada -->
  <div class="custom-spreadsheet-container" *ngIf="isInitialized">
    <table class="spreadsheet-table">
      <!-- Cabeçalho das colunas -->
      <thead>
        <tr>
          <th class="row-header"></th>
          <th *ngFor="let header of columnHeaders; let col = index" 
              class="column-header"
              [style.width.px]="props.defaultColumnWidth">
            {{ header }}
          </th>
        </tr>
      </thead>
      
      <!-- Linhas da planilha -->
      <tbody>
        <tr *ngFor="let rowData of spreadsheetData; let row = index" 
            [style.height.px]="props.defaultRowHeight">
          <!-- Número da linha -->
          <td class="row-header">{{ rowNumbers[row] }}</td>
          
          <!-- Células da planilha -->
          <td *ngFor="let cell of rowData; let col = index" 
              class="spreadsheet-cell"
              [class.selected]="isSelected(row, col)"
              [class.editing]="isEditing(row, col)"
              (click)="selectCell(row, col)"
              (dblclick)="startEditing(row, col)">
            
            <input 
              type="text"
              class="cell-input"
              [id]="'cell-' + row + '-' + col"
              [(ngModel)]="cell.value"
              (blur)="stopEditing()"
              (input)="onCellChange(row, col, cell.value)"
              (keydown)="onKeyDown($event, row, col)"
              [readonly]="props.readonly"
              [style.width.px]="props.defaultColumnWidth - 2"
              [style.height.px]="props.defaultRowHeight - 2">
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Loading overlay -->
  <div class="spreadsheet-loading" *ngIf="!isInitialized">
    <nz-spin nzTip="{{ 'spreadsheet.loading' |translateTA }}"></nz-spin>
  </div>
</div>